import { BusinessDetails } from '../../slices/businessDetails';
import { CoverDetails } from '../../slices/coverDetails';
import { Quote } from '../../slices/quote';
import { RiskClassCode } from '../../types/risk';
import { Nullable } from '../../types/utils';
import { RiskMetaType } from './getRiskMeta';

export const getTaxAuditRisk = ({
  riskMeta,
  coverDetails,
  businessDetails,
  quote,
}: {
  riskMeta: RiskMetaType;
  coverDetails: Nullable<CoverDetails>;
  quote: Nullable<Quote>;
  businessDetails: Partial<BusinessDetails>;
}) => ({
  ...riskMeta,
  riskClassCode: RiskClassCode.TaxAudit,
  riskDetail: {
    riskBPKEmployeeDishonestyTaxAuditTransit: {
      occupationCode: businessDetails.occupation?.anzsicCode ?? '',
      occupationDescription: businessDetails.occupation?.occupation ?? '',
      business: businessDetails.occupation?.occupation ?? '',
      taxAudit: {
        taxAuditSI: coverDetails.taxAudit?.sumInsured ?? 0,
        taxAuditExcess: quote.levelOfExcess!,
        turnover: businessDetails.annualTurnover ?? 0,
        adjustmentIndicator: false,
        adjustmentPercentage: 0,
      },
    },
  },
});
